/**
 * The first arg is used as an initial value and its values overwrites with non-empty values from the rest of args.
 * @param args
 */
export function mergeCustomFields(...args: Record<string, unknown>[]): Record<string, unknown> {
  let result: Record<string, unknown> = {};
  for (let i = 0; i < args.length; i++) {
    const arg = args[i];
    if (i === 0) {
      result = {...arg};
      continue;
    }

    for (const [index, value] of Object.entries(arg)) {
      if (!(result[index] || result[index] === 0) && (value || value === 0)) {
        result[index] = value;
      }
    }
  }

  return result;
}

